//import controller from './blog-slider.controller';
import controller from '../blog.controller';
import templateT1 from './templates/blog-slider-t1.view.html';
import templateT15 from './templates/blog-slider-t15.view.html';
import templateAD from './templates/blog-slider-adaptative.html';

let BlogSliderComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) { return templateAD; }
    else {
        if(response.BLOG.component == 'template_t15'){return templateT15}
        else { return templateT1 }
    }
}

export default BlogSliderComponent;


// WEBPACK FOOTER //
// ./www/components/blog/blog-slider/blog-slider.component.js